import services from 'utils/mockAdapter';
// user list
const ManuJobs = [
    {
        id: '10011',
        number: '1000-52565-65544-1242 ',
        name: 'Sample Job',
        model: 'Eclipse',
        dealer: 'Dealer 1',
        iotcontroler: '510-5565-00'
    },
    {
        id: '10011',
        number: '1000-52565-65544-1242 ',
        name: 'Sample Job',
        model: 'Eclipse',
        dealer: 'Dealer 1',
        iotcontroler: 'Unassigned'
    },
    {
        id: '10011',
        number: '1000-52565-65544-1242 ',
        name: 'Sample Job',
        model: 'Eclipse',
        dealer: 'Dealer 1',
        iotcontroler: '510-5565-00'
    },
    {
        id: '10011',
        number: '1000-52565-65544-1242 ',
        name: 'Sample Job',
        model: 'Eclipse',
        dealer: 'Dealer 1',
        iotcontroler: '510-5565-00'
    },
    {
        id: '10011',
        number: '1000-52565-65544-1242 ',
        name: 'Sample Job',
        model: 'Eclipse',
        dealer: 'Dealer 1',
        iotcontroler: '510-5565-00'
    },
    {
        id: '10011',
        number: '1000-52565-65544-1242 ',
        name: 'Sample Job',
        model: 'Eclipse',
        dealer: 'Dealer 1',
        iotcontroler: '510-5565-00'
    },
    {
        id: '10011',
        number: '1000-52565-65544-1242 ',
        name: 'Sample Job',
        model: 'Eclipse',
        dealer: 'Dealer 1',
        iotcontroler: 'Unassigned'
    },
    {
        id: '10011',
        number: '1000-52565-65544-1242 ',
        name: 'Sample Job',
        model: 'Eclipse',
        dealer: 'Dealer 1',
        iotcontroler: '510-5565-00'
    },
    {
        id: '10011',
        number: '1000-52565-65544-1242 ',
        name: 'Sample Job',
        model: 'Eclipse',
        dealer: 'Dealer 1',
        iotcontroler: 'Unassigned'
    },
    {
        id: '10011',
        number: '1000-52565-65544-1242 ',
        name: 'Sample Job',
        model: 'Eclipse',
        dealer: 'Dealer 1',
        iotcontroler: '510-5565-00'
    },
    {
        id: '10011',
        number: '1000-52565-65544-1242 ',
        name: 'Sample Job',
        model: 'Eclipse',
        dealer: 'Dealer 1',
        iotcontroler: '510-5565-00'
    }
];
// ==============================|| MOCK SERVICES ||============================== //
services.onGet('/api/manufacturers/manujobs/list').reply(200, { ManuJobs });
